import axios from 'axios'
import { url } from './global'

export const getConfiguracion = async () => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.get(`${url}/v2/configuracion`, { headers })
    return res
}

export const updateConfiguracion = async (stockNegativo) => {
    let token = sessionStorage.getItem('token')
    let headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '.concat(token),
    }
    const res = await axios.put(
        `${url}/v2/configuracion`,
        { stockNegativo },
        { headers }
    )
    return res
}
